/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { PostProjectsProjectidSelectionsOptions, PostProjectsProjectidSelectionsResponses } from '../types/PostProjectsProjectidSelections'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /projects/:projectId/selections/}
 */
export function postProjectsProjectidSelections<ThrowOnError extends boolean = true>(options: Options<PostProjectsProjectidSelectionsOptions, ThrowOnError>): Unwrappable<RequestResult<PostProjectsProjectidSelectionsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'POST', url: '/projects/{projectId}/selections/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<PostProjectsProjectidSelectionsResponses, ThrowOnError>>)
}
